/* ═══════════════════════════════════════════════════════════
   js/build-status.js — SSOT статуса сдачи для фронта (блок A1.1)
   JS-зеркало app/lib/Domain/RealEstate/Rating/BuildStatus.php.
   Единый источник «сдан vs строится» для каталога / карты / списка
   вместо россыпи хардкод-regex. Подключается из footer.php ДО
   страничных JS (novostrojki/map/catalog/catalog-map/map-assistant).
   Синхронность с PHP-VO защищена BuildStatusJsSyncTest.
   Сигнатуры всех методов: (status, deadline, progress).
   ═══════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  window.BuildStatus = {
    READY_PCT: 100,
    SORT_UNKNOWN: 9999999,
    _nowYear: new Date().getFullYear(),

    /** Готов/сдан? status==='done' ИЛИ срок несёт «Сдан» ИЛИ прогресс ≥ 100%. */
    isReady: function(status, deadline, progress) {
      return status === 'done'
        || /сдан/i.test(deadline || '')
        || (progress != null && +progress >= this.READY_PCT);
    },

    /** Год сдачи из строки (4 цифры 20xx) или null. «3 кв. 2024» → 2024, «Сдан» → null. */
    deadlineYear: function(deadline) {
      var m = /\b(20\d{2})\b/.exec(deadline || '');
      return m ? +m[1] : null;
    },

    /** Квартал: «3 кв.» → 3, «IV кв.» → 4, иначе 0. */
    quarter: function(deadline) {
      var d = deadline || '';
      var m = /([1-4])\s*кв/i.exec(d);
      if (m) return +m[1];
      var r = /\b(IV|I{1,3})\s*кв/i.exec(d);
      if (r) return ({ I: 1, II: 2, III: 3, IV: 4 })[r[1].toUpperCase()] || 0;
      return 0;
    },

    /** Дедлайн в прошлом, но ЖК всё ещё строится → данные протухли. */
    isStale: function(status, deadline, progress) {
      if (this.isReady(status, deadline, progress)) return false;
      var y = this.deadlineYear(deadline);
      return y !== null && y < this._nowYear;
    },

    /** Человеко-бейдж готовности: «Сдан 2023» / «Сдан» / «Построен» / «Строится, N%». */
    label: function(status, deadline, progress) {
      if (this.isReady(status, deadline, progress)) {
        if (/сдан/i.test(deadline || '')) return deadline;
        return status === 'done' ? 'Сдан' : 'Построен';
      }
      if (progress != null) return 'Строится, ' + Math.max(0, Math.min(100, +progress)) + '%';
      return 'Строится';
    },

    /** Срок для строящихся: дата либо «срок уточняется» (пустой/протухший). Готов → ''. */
    deadlineLabel: function(status, deadline, progress) {
      if (this.isReady(status, deadline, progress)) return '';
      if (this.isStale(status, deadline, progress)) return 'срок уточняется';
      return deadline ? deadline : 'срок уточняется';
    },

    /** Значение ячейки «Сдача» (зеркало PHP jk_content): готов→label, строится→deadlineLabel. */
    cell: function(status, deadline, progress) {
      return this.isReady(status, deadline, progress)
        ? this.label(status, deadline, progress)
        : this.deadlineLabel(status, deadline, progress);
    },

    /** Готовая строка срока: предлог «в» подходит только одиночной дате. */
    deadlineLine: function(deadline, status) {
      var text = String(deadline || '').trim();
      if (!text) return '';
      if (status && /^срок\s+уточняется$/i.test(text)) {
        return 'Сдача: ' + text + ', ' + String(status).toLowerCase();
      }
      if (/^(?:сдан|построен|срок|сдача)(?:\s|:|$)/i.test(text)) return text;
      var range = /^от\s/i.test(text) || /(?:\s[–—]\s|\d\s*[–—-]\s*\d)/.test(text);
      var line = /^до\s/i.test(text) ? 'Сдача ' + text
        : (range ? 'Сдача: ' + text : 'Сдача в ' + text);
      return status ? line + ', ' + String(status).toLowerCase() : line;
    },

    /** Бейдж среза для карты/каталога без дублей «Сдан·Сдан»: готов→«Сдан 2023»/«2023 · Сдан»/«Сдан». */
    mapBadge: function(status, deadline, progress) {
      if (this.isReady(status, deadline, progress)) {
        if (/сдан/i.test(deadline || '')) return deadline;          // уже «Сдан 2023»
        return deadline ? (deadline + ' · Сдан') : 'Сдан';          // «2023 · Сдан»
      }
      if (this.isStale(status, deadline, progress)) return '';       // протухший срок стройки — прячем
      return deadline || '';
    },

    /**
     * Отбор «Год сдачи» / «Сдача» по сроку ЖК (блок 8.4 «ФИД ЯНДЕКСА», 24.09.2026).
     * want: '' — любой срок; 'Сдан' — status 'done' или «Сдан» в сроке; 'YYYY' — в строке
     * срока есть этот год («4 кв. 2026», «Сдан 2026», «2026»). Прочее — ничего не отбирает.
     * Зеркало PHP Deadline::sqlBuildingCondition(); паритет держит общий набор случаев
     * tests/Fixtures/deadline-filter-cases.json. Было: карта сравнивала `=== '2026'`
     * и находила 1 ЖК Москвы из 14.
     * ⛔ «Сдан» НЕ через isReady (доводка r3): прогресс стройки фильтр не читает, как и SQL.
     * Дом на 100 % без ввода label() подписывает «Построен», а не «Сдан».
     */
    matchesDeadline: function(want, status, deadline) {
      if (!want) return true;
      if (want === 'Сдан') return status === 'done' || /сдан/i.test(deadline || '');
      if (!/^20\d{2}$/.test(want)) return false;
      return new RegExp('(^|\\D)' + want + '(\\D|$)').test(deadline || '');
    },

    /** Числовой ранг сортировки «по сдаче»: готов→0, иначе год*10+квартал, неизвестно→в конец. */
    sortRank: function(status, deadline, progress) {
      if (this.isReady(status, deadline, progress)) return 0;
      var y = this.deadlineYear(deadline);
      if (y === null) return this.SORT_UNKNOWN;
      return y * 10 + this.quarter(deadline);
    }
  };
})();
